import ms from 'ms';
import moment from 'moment';

export function useIntervalTimer(duration, updateCb) {
  const durationMs = ms(duration);
  const timerUntil = moment().add(durationMs, 'milliseconds');

  const sendCodeInterval = setInterval(() => {
    const secondsLeft = timerUntil.diff(moment(), 'seconds');
    updateCb(secondsLeft, timerUntil);

    if (moment().isSameOrAfter(timerUntil)) {
      updateCb(null, null);
      clearInterval(sendCodeInterval);
    }
  }, 1000);

  return timerUntil;
}
